import * as React from 'react';
import { CompositeComponent } from './types';
import { withPlaceholder } from './withPlaceholder';

interface ErrorProps {
    error?: any;
}

const DefaultErrorPlaceholder = () => <p>Error</p>;

export default (ErrorPlaceholder?: CompositeComponent<any>) =>
    withPlaceholder<ErrorProps>(
        ErrorPlaceholder || DefaultErrorPlaceholder,
        ({ error }) => !!error
    );



// WEBPACK FOOTER //
// ./src/client/components/withErrorPlaceholder.tsx